/* eslint-disable react-hooks/exhaustive-deps */
import { Checkbox, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TableSortLabel } from "@mui/material";
import { ArrowDropDown } from "@mui/icons-material";
import React, { FC, useState, useEffect } from "react";
import { Componente, ID_INVERSOR, ID_MODULO, InversorStringBox } from "../../types";
import { CollectionUtil } from "src/framework/commons/CollectionUtil";
import { Formater } from "src/framework/commons/Formater";

export interface InversoresStringBoxProperties {
    list: Componente[];
    inversoresList: InversorStringBox[];
    onChange?: Function;
}

interface InversoresStringBoxState {
    list: any;
    sorterField: SORTER_FILED
    selectedList?: any;
}

enum SORTER_FILED {
    POTENCIA_ASC = "potencia",
    POTENCIA_DESC = "-potencia",
    MODELO_ASC = "modelo",
    MODELO_DESC = "-modelo",
    CODIGO_ASC = "id",
    CODIGO_DESC = "-id",
}

const sorter = (componentes: Componente[], field: SORTER_FILED): any => {
    const list: any = componentes.map((c) => {

        let potencia = null;

        if ([ID_INVERSOR].includes(parseInt(String(c.categoria_componentes_id)))) {
            potencia = c.atributos?.INVERSOR_POTENCIA_MAXIMA_SAIDA
        }


        return { ...c, potencia: potencia }
    }).sort(CollectionUtil.singleSort(field))

    return { list: (list as Componente[]), sorterField: field };
}


const InversoresStringBox: FC<InversoresStringBoxProperties> = ({
    list,
    inversoresList = [],
    onChange = (value: any) => { }
}) => {

    const [state, setState] = useState<InversoresStringBoxState>({
        list: [],
        selectedList: inversoresList,
        sorterField: SORTER_FILED.POTENCIA_ASC
    });

    useEffect(() => {
        setState({ ...state, ...sorter(list, SORTER_FILED.POTENCIA_ASC) })
    }, [list])

    // const handleToggle = (
    //     event: React.ChangeEvent<{ value: unknown; checked: boolean }>
    //   ) => {
    //     const selecteds: any = [...inversoresList];
    //     const value = parseInt(event.target.value as string);
    //     const idx = selecteds.findIndex((item: InversorStringBox) => item.inversor_id === value);

    //     if (event.target.checked) {
    //       if (idx < 0) {
    //         selecteds.push({ inversor_id: value });
    //       }
    //       if (idx > -1 && Object.keys(selecteds[idx]).includes("@remove")) {
    //         delete selecteds[idx]["@remove"];
    //       }
    //     } else {
    //       if (idx > -1) {
    //         if (Object.keys(selecteds[idx]).includes("created_at")) {
    //             selecteds[idx]["@remove"] = true
    //         } else {
    //             selecteds.splice(idx, 1)
    //         }
    //       }
    //     }

    //     if (onChangeValue) {
    //       onChangeValue(selecteds);
    //     }
    //     return inversoresList;
    //   };

    const [checkedAll, setCheckedAll] = useState<boolean>(inversoresList.length > 0 && inversoresList.length === list.length);

    const handleToggleAll = (event: React.ChangeEvent<{ value: unknown; checked: boolean }>): void => {
        let selecteds: any = [...inversoresList];
        if (event.target.checked) {
            for (let componente of list) {
                selecteds.push({ inversor_id: componente.id });
            }
        } else {
            selecteds = []
        }
        setCheckedAll(event.target.checked);

        if (onChange) {
            onChange(selecteds);
        }
    }

    const handleToggle = (
        event: React.ChangeEvent<{ value: unknown; checked: boolean }>
    ) => {
        const selecteds: any = [...inversoresList];
        const value = parseInt(event.target.value as string);
        const idx = selecteds.findIndex((item: any) => item.inversor_id === value);

        if (event.target.checked) {
            if (idx < 0) {
                selecteds.push({ inversor_id: value });
            }
        } else {
            if (idx > -1) {
                selecteds.splice(idx, 1);
            }
        }

        if (onChange) {
            onChange(selecteds);
        }
        return state.selectedList;
    };


    return <>
        <section>
            <div className="row">
                <div className="X12">


                    <Paper elevation={0}>
                        <TableContainer style={{ maxHeight: "660px" }}>
                            <Table size="small" style={{ width: "100%", tableLayout: "auto" }}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell padding="checkbox">
                                            <Checkbox
                                                onChange={handleToggleAll}
                                                value={checkedAll}
                                                checked={checkedAll}
                                                indeterminate={inversoresList.length > 0 && list.length !== inversoresList.length}
                                            />
                                        </TableCell>
                                        <TableCell width={100} align="right">
                                            <TableSortLabel
                                                IconComponent={ArrowDropDown}
                                                active={[String(SORTER_FILED.POTENCIA_ASC), String(SORTER_FILED.POTENCIA_DESC)].includes(String(state.sorterField))}
                                                direction={state?.sorterField && state?.sorterField[0] === "-" ? "desc" : "asc"}
                                                onClick={() => {
                                                    setState({
                                                        ...state,
                                                        ...sorter(state.list, state.sorterField === SORTER_FILED.POTENCIA_ASC ? SORTER_FILED.POTENCIA_DESC : SORTER_FILED.POTENCIA_ASC)
                                                    })
                                                }}
                                            >
                                                Potência
                                            </TableSortLabel>
                                        </TableCell>

                                        <TableCell width={260} >
                                            <TableSortLabel
                                                IconComponent={ArrowDropDown}
                                                active={[String(SORTER_FILED.MODELO_ASC), String(SORTER_FILED.MODELO_DESC)].includes(String(state.sorterField))}
                                                direction={state?.sorterField && state?.sorterField[0] === "-" ? "desc" : "asc"}
                                                onClick={() => {
                                                    setState({
                                                        ...state,
                                                        ...sorter(state.list, state.sorterField === SORTER_FILED.MODELO_ASC ? SORTER_FILED.MODELO_DESC : SORTER_FILED.MODELO_ASC)
                                                    })
                                                }}
                                            >
                                                Modelo
                                            </TableSortLabel>
                                        </TableCell>
                                        <TableCell align="right" width={100}>
                                            <TableSortLabel
                                                IconComponent={ArrowDropDown}
                                                active={[String(SORTER_FILED.CODIGO_ASC), String(SORTER_FILED.CODIGO_DESC)].includes(String(state.sorterField))}
                                                direction={state?.sorterField && state?.sorterField[0] === "-" ? "desc" : "asc"}
                                                onClick={() => {
                                                    setState({
                                                        ...state,
                                                        ...sorter(state.list, state.sorterField === SORTER_FILED.CODIGO_ASC ? SORTER_FILED.CODIGO_DESC : SORTER_FILED.CODIGO_ASC)
                                                    })
                                                }}
                                            >
                                                Código
                                            </TableSortLabel>
                                        </TableCell>
                                        <TableCell />
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {state.list.map((componente: any, index: number) => {
                                        const unidadePotencia = ID_MODULO === componente.categoria_componentes_id ? "Wp" : "W"

                                        return (
                                            <TableRow key={index}>
                                                <TableCell padding="checkbox">
                                                    <Checkbox
                                                        edge="end"
                                                        value={componente.id}
                                                        onChange={handleToggle}
                                                        checked={
                                                            inversoresList.findIndex(
                                                                (item: any) => item.inversor_id === componente.id
                                                            ) > -1
                                                        }
                                                    />
                                                </TableCell>
                                                <TableCell align="right">{Formater.toString(componente?.potencia || 0)} {unidadePotencia}</TableCell>
                                                <TableCell>{componente.modelo}</TableCell>
                                                <TableCell align="right">{componente.id}</TableCell>
                                                <TableCell />
                                            </TableRow>
                                        )
                                    })}

                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Paper>



                    {/* <List dense>
                        {listIComponenteInversores.map((componente: Componente) => {
                            return (
                                <ListItem key={componente.id} button>
                                    <ListItemAvatar>
                                        <Icon>image</Icon>
                                    </ListItemAvatar>
                                    <ListItemText
                                        id={`${componente.id}`}
                                        primary={componente.modelo}
                                    />
                                    <ListItemSecondaryAction>
                                        <Checkbox
                                            edge="end"
                                            value={componente.id}
                                            onChange={handleToggle}
                                            checked={
                                                inversoresList.findIndex(
                                                    (item: InversorStringBox) => item.inversor_id === componente.id && !Object.keys(item).includes("@remove")
                                                ) > -1
                                            }
                                        />
                                    </ListItemSecondaryAction>
                                </ListItem>
                            );
                        })}
                    </List> */}
                </div>
            </div>
        </section>
    </>
}

export { InversoresStringBox }